import { noddiAsync, URLKeys } from 'noddi-async';
import { useAuthContext } from 'noddi-web';

/**
 * Whether a user group has at least one saved address (needed for stationary payment).
 * Auth-gated: the endpoint 401s for anonymous visitors on public pages (/b/:slug, POS, payment info).
 */
export function useUserGroupHasAddresses(userGroupId: number | null | undefined) {
  const { isLoggedIn } = useAuthContext();
  const enabled = isLoggedIn && userGroupId != null;

  const {
    data: addresses,
    isLoading,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getUserGroupAddresses,
    input: { userGroupId: userGroupId! },
    queryConfig: {
      enabled
    }
  });

  return {
    hasAddress: (addresses?.results.length ?? 0) > 0,
    isLoading: enabled && isLoading,
    error: error ?? null,
    addresses: addresses?.results ?? []
  };
}
